export const menuItems = [
  {
    id: "dashboard",
    label: "Dashboard",
    icon: "mdi mdi-view-dashboard",
    link: "/dashboard",
    permission: "dashboard",
    types: ["GET", "POST", "PUT", "DELETE"],
  },
  {
    id: "users",
    label: "Users",
    icon: "ion ion-md-people",
    link: "/#",
    isSubMenu: true,
    permission: "users",
    types: ["GET", "POST", "PUT", "DELETE"],
    subItems: [
      {
        id: "appUsers",
        label: "App Users",
        link: "/#",
        icon: "mdi mdi-cellphone",
        permission: "appUsers",
        types: ["GET", "POST", "PUT", "DELETE"],
        isSubMenu: true,
        subItems: [
          {
            id: "allAppUsers",
            label: "All App Users",
            link: "/user-list",
            icon: "mdi mdi-account",
            permission: "allAppUsers",
            types: ["GET", "POST", "PUT", "DELETE"],
          },
          {
            id: "under18Users",
            label: "Under 18 Users",
            link: "/under18Users",
            icon: "mdi mdi-human-child",
            permission: "under18Users",
            types: ["GET", "POST", "PUT", "DELETE"],
          },
        ],
      },
      {
        id: "businessUsers",
        label: "Business Users",
        link: "/Business-user-list",
        icon: "ion ion-md-business",
        permission: "businessUsers",
        types: ["GET", "POST", "PUT", "DELETE"],
        isSubMenu: true,
        subItems: [
          {
            id: "allBusinessUsers",
            label: "Business Users",
            link: "/business-user-list",
            icon: "mdi mdi-account",
            permission: "allBusinessUsers",
            types: ["GET", "POST", "PUT", "DELETE"],
          },
          {
            id: "claimRequests",
            label: "Claim Requests",
            link: "/Claim-requests",
            icon: "mdi mdi-account",
            permission: "claimRequests",
            types: ["GET", "POST", "PUT", "DELETE"],
          },
        ],
      },
    ],
  },
  {
    id: "email",
    label: "Email",
    icon: "ion ion-md-mail",
    link: "/#",
    isSubMenu: true,
    types: ["GET", "POST", "PUT", "DELETE"],
    subItems: [
      {
        id: "emailTemplate",
        label: "Email-Template",
        link: "/EmailTemplateTable",
        icon: "ion ion-md-list-box",
        permission: "emailTemplate",
        types: ["GET", "POST", "PUT", "DELETE"],
      },
    ],
  },
  {
    id: "category",
    label: "Category",
    icon: "ion ion-md-albums",
    link: "/categoryList",
    permission: "category",
    types: ["GET", "POST", "PUT", "DELETE"],
  },
  {
    id: "portalUsers",
    label: "Portal Users",
    icon: "mdi mdi-monitor-eye",
    link: "/PortalUsers",
    permission: "portalUsers",
    types: ["GET", "POST", "PUT", "DELETE"],
  },
  {
    id: "deleted",
    label: "Deleted",
    icon: "ion ion-md-trash",
    link: "/#",
    isSubMenu: true,
    types: ["GET", "POST", "PUT", "DELETE"],
    subItems: [
      {
        id: "deletedUsers",
        label: "Deleted Users",
        link: "/deleted-users",
        icon: "ion ion-md-person",
        permission: "deletedUsers",
        types: ["GET", "POST", "PUT", "DELETE"],
      },
      {
        id: "deletedGabs",
        label: "Deleted Gabs",
        link: "/deleted-gabs",
        icon: "ion ion-md-list-box",
        permission: "deletedGabs",
        types: ["GET", "POST", "PUT", "DELETE"],
      },
      {
        id: "deletedComments",
        label: "Deleted Comments",
        link: "/deleted-comments",
        icon: "ion ion-md-chatboxes",
        permission: "deletedComments",
        types: ["GET", "POST", "PUT", "DELETE"],
      },
    ],
  },
  {
    id: "siteSettings",
    label: "Site Settings",
    icon: "mdi mdi-view-dashboard",
    link: "/site-settings",
    permission: "siteSettings",
    types: ["GET", "POST", "PUT", "DELETE"],
  },
  {
    id: "institutions",
    label: "Institutions",
    icon: "mdi mdi-school",
    link: "/institutions",
    permission: "institutions",
    types: ["GET", "POST", "PUT", "DELETE"],
  },
  {
    id: "forms",
    label: "Forms",
    icon: "mdi mdi-form-select",
    link: "/#",
    permission: "forms",
    types: ["GET", "POST", "PUT", "DELETE"],
    isSubMenu: true,
    subItems: [
      {
        id: "formList",
        label: "Form List",
        link: "/forms",
        icon: "mdi mdi-format-list-bulleted",
        permission: "forms",
        types: ["GET", "POST", "PUT", "DELETE"],
      },
      {
        id: "submittedForms",
        label: "Submitted Forms",
        link: "/all-responses",
        icon: "mdi mdi-file-document-check-outline",
        permission: "forms",
        types: ["GET", "POST", "PUT", "DELETE"],
      },
    ],
  },
  {
    id: "newsletter",
    label: "Newsletter",
    icon: "mdi mdi-newspaper",
    link: "/#",
    isSubMenu: true,
    types: ["GET", "POST", "PUT", "DELETE"],
    subItems: [
      {
        id: "emailSubscriptions",
        label: "Email Subscriptions",
        link: "/emailSubscriptions",
        icon: "mdi mdi-email",
        permission: "emailSubscriptions",
        types: ["GET", "POST", "PUT", "DELETE"],
      },
    ],
  },
  {
    id: "payments",
    label: "Payment",
    icon: "mdi mdi-cash",
    link: "/#",
    isSubMenu: true,
    permission: "payments",
    types: ["GET", "POST", "PUT", "DELETE"],
    subItems: [
      {
        id: "tickets",
        label: "Tickets",
        link: "/tickets",
        icon: "mdi mdi-ticket-confirmation",
        permission: "tickets",
        types: ["GET", "POST", "PUT", "DELETE"],
      },
      {
        id: "requests",
        label: "Requests",
        link: "/requests",
        icon: "mdi mdi-file-document-outline",
        permission: "requests",
        types: ["GET", "POST", "PUT", "DELETE"],
      },
      {
        id: "transactions",
        label: "Transactions",
        link: "/transactions",
        icon: "mdi mdi-swap-horizontal",
        permission: "transactions",
        types: ["GET", "POST", "PUT", "DELETE"],
      },
    ]
  },
  {
    id: "kyc",
    label: "KYC",
    icon: "mdi mdi-account-check",
    link: "/kyc",
    permission: "kyc",
    types: ["GET", "POST", "PUT", "DELETE"],
  },
]
